import { render, staticRenderFns } from "./TinyInfo.vue?vue&type=template&id=a9a8d4c0&scoped=true"
import script from "./TinyInfo.vue?vue&type=script&lang=ts"
export * from "./TinyInfo.vue?vue&type=script&lang=ts"
import style0 from "./TinyInfo.vue?vue&type=style&index=0&id=a9a8d4c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a8d4c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9a8d4c0')) {
      api.createRecord('a9a8d4c0', component.options)
    } else {
      api.reload('a9a8d4c0', component.options)
    }
    module.hot.accept("./TinyInfo.vue?vue&type=template&id=a9a8d4c0&scoped=true", function () {
      api.rerender('a9a8d4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/TinyInfo.vue"
export default component.exports